export default __webpack_public_path__ + "static/works-afdbd6745e8e87bf112b2d446e2b11ba.jpg";